import src from "IMAGE";
export default { src, width: 4801, height: 1080, blurWidth: 0, blurHeight: 0};
